import Model, { attr, belongsTo } from '@ember-data/model';
import type CompanyModel from './company.ts';
import { Type } from '@warp-drive/core-types/symbols';

export type TasInvoiceType = 'BENEFIT' | 'FEE';
export type TasInvoiceFundingType = 'PREFUND' | 'INVOICED' | 'DIRECTDRAW';
export type TasInvoiceState = 'CREATED' | 'APPROVED' | 'FUNDED' | 'CANCELED';

export default class TasInvoiceModel extends Model {
  @attr declare amount: number;
  @attr declare description: string;
  @attr declare invoiceType: TasInvoiceType;
  @attr declare fundingType: TasInvoiceFundingType;
  @attr declare invoiceDate: string;
  @attr declare metadata: Record<string, unknown> | null;
  @attr declare paidAt: string | null;
  @attr declare state: TasInvoiceState;

  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;

  [Type] = 'tas-invoice' as const;
}
